import Vue from 'vue';
import router from "../router";
import VueMatomo from 'vue-matomo';
import EnvironmentInfoService from "@/api/EnvironmentInfoService";
declare const window: any;
// require user consent before processing data
const _paq = window._paq || [];
_paq.push(['requireConsent']);
_paq.push(['trackPageview']);

let matomoUrl, matomoId;

EnvironmentInfoService.getEnvironmentInfo()
    .then((value:any) => {
      matomoUrl = value.matomoUrl;
      matomoId = value.matomoId;
      console.log(matomoUrl);

      Vue.use(VueMatomo, {
        host: matomoUrl,
        siteId: matomoId,
        trackerFileName: 'matomo',
        router: router,
        enableLinkTracking: true,
        requireConsent: true,
        trackInitialView: true,
        disableCookies: false,
        enableHeartBeatTimer: false,
        heartBeatTimerInterval: 15,
        debug: false,
        userId: undefined,
        cookieDomain: undefined,
        domains: undefined,
        preInitActions: []
      });
    }).catch((reason:any) => {
      matomoUrl = "";
      matomoId = 0;
    });


